import { render } from "./FormEditorView.vue?vue&type=template&id=06426ec3&scoped=true"
import script from "./FormEditorView.vue?vue&type=script&lang=js"
export * from "./FormEditorView.vue?vue&type=script&lang=js"

import "./FormEditorView.vue?vue&type=style&index=0&id=06426ec3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06426ec3"]])

export default __exports__